module.exports = __webpack_public_path__ + "img/simbolo-de-interfaz-de-historial-de-navegacion-de-un-reloj-con-una-flecha.fcc92226.png";